<template>
  <div class="login-page">
    <div class="login-lang-switch">
      <el-dropdown @command="changeLanguage" trigger="click">
        <span class="el-dropdown-link lang-switch-link">
          <img class="lang-switch-icon" src="../assets/globe.svg" alt="">
          <span class="lang-switch-text">{{ currentLangLabel }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh_CN">{{ $t('information.Simplified_Chinese') }}</el-dropdown-item>
          <el-dropdown-item command="en">{{ $t('information.English') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <auth-brand-layout>
      <div class="auth-card">
        <h3 class="auth-card__title">{{ $t('auth.loginTitle') }}</h3>

        <div class="auth-tabs">
          <span :class="{ active: code }" @click="chcode">{{ $t('auth.codeLoginTab') }}</span>
          <span :class="{ active: pass }" @click="chpass">{{ $t('auth.passwordLoginTab') }}</span>
        </div>

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="auth-form">
          <el-form-item prop="phone">
            <el-input
              oninput="value=value.replace(/\D/gi,'')"
              :placeholder="$t('auth.phonePlaceholder')"
              v-model="ruleForm.phone"
              :maxlength="max"
              class="auth-input input-with-select"
            >
              <el-select v-model="ruleForm.countryIndex" slot="prepend" class="country-select" @change="changeCode">
                <div class="el-input_search">
                  <img src="../assets/search.svg" alt="">
                  <input type="text" :placeholder="$t('signIn.searchArea')" class="el-input__inner"
                    v-model="dropDownValue" @keyup="dropDownSearch">
                </div>
                <el-option v-for="item in countries" :key="item.id"
                  :label="`+${item.country_code} ${item.name}`" :value="item.id">
                  <span>+{{ item.country_code }} {{ item.name }}</span>
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>

          <el-form-item v-if="code" prop="verification">
            <el-input maxlength="6" :placeholder="$t('auth.codePlaceholder')" v-model="ruleForm.verification"
              oninput="value=value.replace(/\D/gi,'')" class="auth-input input-with-send">
              <el-button slot="append" @click="countDown">
                <span v-if="maxTotaltime == setTime">{{ $t('Send') }}</span>
                <span v-else>{{ setTime }} s</span>
              </el-button>
            </el-input>
          </el-form-item>

          <el-form-item v-if="pass" prop="password">
            <el-input :type="flagType" :placeholder="$t('auth.passwordPlaceholder')" v-model="ruleForm.password"
              class="auth-input input-with-pass">
              <img slot="suffix" :src="flag ? openeye : nopeneye" class="password-eye" alt="" @click="getFlag()">
            </el-input>
          </el-form-item>

          <el-button v-if="code" class="auth-submit" type="primary" @click="verifyClick">{{ $t('auth.login') }}</el-button>
          <el-button v-if="pass" class="auth-submit" type="primary" @click="submitForm">{{ $t('auth.login') }}</el-button>

          <div class="auth-terms">
            <template v-if="code">
              <span>{{ $t('auth.termsLogin') }}</span>
              <span class="auth-link" @click="toUserService">《{{ $t('ServiceAgreement') }}》</span>
              <span>{{ $t('and') }}</span>
              <span class="auth-link" @click="toPolicy">《{{ $t('PrivacyPolicy') }}》</span>
            </template>
            <template v-else>
              <span>{{ $t('By continuing, you agree to our ') }}</span>
              <span class="auth-link" @click="toUserService">《{{ $t('ServiceAgreement') }}》</span>
              <span>{{ $t('and') }}</span>
              <span class="auth-link" @click="toPolicy">《{{ $t('PrivacyPolicy') }}》</span>
            </template>
          </div>
        </el-form>
      </div>
    </auth-brand-layout>
  </div>
</template>

<script>
  import {
    setStore,
    getStore,
    keys
  } from '@/store';
  import { getLocaleShortLabel, switchUserLanguage } from '@/utils/lang';
  import { redirectAfterLogin, redirectIfLoggedIn } from '@/utils/auth';
  import { appUrl } from '@/utils/appUrl';
  import { ROUTE } from '@/router/paths';
  import AuthBrandLayout from '@/components/AuthBrandLayout';
  export default {
    name: 'loginPassword',
    components: {
      AuthBrandLayout
    },
    inject: ['reload'],
    data() {
      // 手机号验证
      const loginCheck = async (rule, value, callback) => {
        let reg = /^\d{1,}$/
        if (value.length < 1) {
          this.changeLoginFlag = 2
          return callback(new Error(this.$t('errorprompt.phoneEmpty')))
        } else if (!reg.test(value)) {
          this.changeLoginFlag = 2
          return callback(new Error(this.$t('errorprompt.phoneError')))
        } else {
          this.changeLoginFlag = 1
          callback()
        }
      }
      return {
        qvhao: [],
        areaCodeData: [],
        dropDownValue: '',
        valueMeta: [],
        ruleForm: {
          phone: '',
          // areaCode: '',
          pwdType: 'password',
          seen: false,
          countryIndex: '', //区号
          code: '',
          verification: '', //验证码
          password: '', //密码
        },
        resetForm: {
          newPassword: '',
          ConfirmNewPassword: '',
          NewSeen: false,
          confirmNewSeen: false,
          newPwdType: 'password',
          confirmNewPwdType: 'password'
        },
        rules: {
          phone: [{
              required: true,
              validator: loginCheck,
              trigger: 'blur'
            },
            {
              min: 6,
              message: this.$t('errorprompt.phoneError'),
              trigger: 'blur'
            },
          ],
          verification: [{
              required: true,
              message: this.$t('errorprompt.verificationEmpty'),
              trigger: 'blur'
            },
            {
              max: 6,
              min: 6,
              message: this.$t('errorprompt.verificationError'),
              trigger: 'blur'
            },
          ],
          password: [{
            required: true,
            message: this.$t('errorprompt.passwordEmpty'),
            trigger: 'blur'
          }]
        },
        changeLoginFlag: 1,
        changeAgainFlag: 1,
        // openeye: require('@/assets/eye.svg'), // 图片地址
        // nopeneye: require('@/assets/eye-off.svg'), // 图片地址
        // pasteResult: [], // 存放粘贴进来的数字
        // 验证码倒计时
        maxTotaltime: 60,
        setTime: 60,
        timer: null,
        inputcode: '',
        // code: '',
        // 模块判断
        tishi: '', //浏览器提示
        max: 11,
        time: 0,
        code: true,
        pass: false,
        flag: false,
        flagType: 'password',
        countries: [],
        openeye: require('../assets/eye.svg'),
        nopeneye: require('../assets/eye-off.svg'),
        url: window.location.origin,
      }
    },
    computed: {
      currentLangLabel () {
        return getLocaleShortLabel(this.$i18n.locale)
      }
    },
    created() {
      if (getStore(keys.token)) {
        redirectIfLoggedIn(this)
      }
      this.getCountryCode()

      function gethtmlfontsize() {
        // 三个步骤:
        // 1.获取html的高,
        let htmlheight = document.documentElement.clientHeight || document.body
        .clientHeight; //有些浏览器documentElement获取不到,那就使用后面的body
        console.log(htmlheight);
        // 2.htmlDom
        let htmlDom = document.getElementsByTagName("html")[0]
        //3.设置根元素样式
        htmlDom.style.fontSize = 10 * htmlheight / 375 + 'px';
        console.log(htmlDom.style.fontSize)
        htmlDom.style.height = '100%';
      }
      // 调用一次
      gethtmlfontsize();
      // 添加监听事件(resize是监听的意思)
      window.addEventListener('resize', gethtmlfontsize)
    },
    mounted() {

      var userAgent = navigator.userAgent;
      var Chrome = userAgent.indexOf('Chrome') > -1;
      var Edge = userAgent.indexOf('Edg') > -1;
      if (!(Chrome || Edge)) {
        this.tishi = this.$t('Please use');

      }
    },
    methods: {
      changeLanguage (lang) {
        switchUserLanguage(this, lang)
      },
      getFlag() {
        this.flag = !this.flag
        this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
      },
      chcode() {
        this.code = true;
        this.pass = false;
        this.$refs.ruleForm.resetFields();
      },
      chpass() {
        this.code = false;
        this.pass = true;
        this.$refs.ruleForm.resetFields();
      },
      changeCode() {
        this.countries.map((item) => {
          if (this.ruleForm.countryIndex == item.id) {
            this.ruleForm.code = item.country_code
          }
        });
        if (this.ruleForm.code == '86') {
          if (this.ruleForm.phone.length > 11) {
            this.ruleForm.phone = ''
          }
          this.max = 11
        } else if (this.ruleForm.code == '1') {
          if (this.ruleForm.phone.length > 10) {
            this.ruleForm.phone = ''
          }
          this.max = 10
        } else {
          this.max = 15
        }
      },
      // 国家区号
      getCountryCode() {
        this.$http.get('/api/base/country?page=1&pagesize=999&keywords=&country_code=').then((res) => {
          console.log(111111111, res)
          this.countries = res.data.data.map((item) => {
            return {
              id: item.id,
              name: item.title,
              country_code: item.country_code
            };
          });
          this.qvhao = this.countries
          setStore(keys.areaCodeList, res.data.data)
          this.ruleForm.countryIndex = this.countries[1].id
          this.ruleForm.code = this.countries[1].country_code
        })
      },
      dropDownSearch() {
        var _this = this
        if (_this.dropDownValue) {
          _this.countries = []
          _this.qvhao.find(item => {
            let name = ' +' + item.country_code + item.name
            if (name.toLowerCase().indexOf(_this.dropDownValue.toLowerCase()) != -1) {
              _this.countries.push(item)
            }
          })
        } else {
          _this.countries = _this.qvhao
        }
      },
      toPassword() {
        this.chpass()
      },
      toUserService() {
        window.open(appUrl(ROUTE.SERVICE))
      },
      toPolicy() {
        window.open(appUrl(ROUTE.PRIVACY))
      },
      // 验证码登录
      verifyClick() {
        this.$refs.ruleForm.validate((valid, msg) => {
          if (!valid) {
            this.$message(msg['phone'][0].message)
            return false
          }
          this.$http.post('/api/uniCaptcha', {
            mobile: this.ruleForm.phone,
            code: this.ruleForm.verification,
            country_code: this.ruleForm.code
          }).then((res) => {
            if (res.data.code == 200) {
              console.log(res)
              this.$http.post('/api/checkCodeSignin', {
                mobile: this.ruleForm.phone,
                code: this.ruleForm.verification,
                country_code: this.ruleForm.code,
                time_zone: this.utils.getTimeZoneCity(),
                utm_source: 'pc'
              }).then((res) => {
                if (res.data.code == 200) {
                  console.log(res)
                  setStore(keys.userInfo, res.data.data);

                  setStore(keys.token, res.data.data.token)

                  redirectAfterLogin(this)
                  //   }
                  // }, 2000)
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  })
                }
              }).catch((error) => {
                console.log(error) // 请求失败返回的数据
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })
        })
      },
      submitForm() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$http.post('/api/signin', {
              mobile: this.ruleForm.phone,
              password: this.ruleForm.password,
              country_code: this.ruleForm.code,
              time_zone: this.utils.getTimeZoneCity()
            }).then((res) => {
              if (res.data.code == 200) {
                setStore(keys.userInfo, res.data.data)
                setStore(keys.token, res.data.data.token)
                redirectAfterLogin(this)
              } else {
                if (res.data.msg == 'Password input error') {
                  this.$message({
                    message: this.$t('Wrong password'),
                    type: 'error',
                    customClass: 'dismessageclass',
                  })
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  })
                }
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })

          }
        });

      },
      // 倒计时
      setCount(setTime) {
        if (setTime >= 0) {
          if (!this.timer) {
            this.timer = setInterval(() => {
              if (this.setTime > 0 && this.setTime <= this.maxTotaltime) {
                this.setTime--
              } else {
                clearInterval(this.timer)
                this.timer = null
                this.setTime = 60
              }
            }, 1000)
          }
        }
      },
      countDown() { //发送验证码
        if (!this.ruleForm.phone) {
          this.$message({
            message: this.$t('errorprompt.phoneEmpty'),
            type: 'warning'
          })
          return false
        }
        if (this.maxTotaltime == this.setTime) {
          if (this.changeLoginFlag == 1) {
            this.$http.post('/api/reviewMember', {
              mobile: this.ruleForm.phone,
              country_code: this.ruleForm.code
            }).then((body) => {
              if (body.data.code == 200) {
                if (body.data.data.is_exist == 0) {
                  //   name: 'newUser',
                  //   params: {
                  //     phone: this.ruleForm.phone,
                  //   },
                  this.$message({
                    message: this.$t('User Does Not Exist'),
                    type: 'warning',
                    customClass: 'messageclass',
                    //   center: true
                  });
                  return false
                }
                this.$http.post('/api/signin/checkCode', {
                  mobile: this.ruleForm.phone,
                  length: 6,
                  country_code: this.ruleForm.code
                }).then((res) => {
                  if (res.data.code == 200) {
                    this.setCount(this.setTime)
                    console.log(res)

                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: 'warning'
                    })
                  }
                }).catch((error) => {
                  console.log(error) // 请求失败返回的数据
                })
              }
            })

          }
        }
      },

    }
  }
</script>

<style lang="less">
@import '../styles/auth-page.less';
</style>
<style lang="less">
.el-dropdown-menu {
  padding: 20px;
  border-radius: 8px;
}

.el-dropdown-menu__item {
  font-family: Sofia Pro;
  font-size: 14px;
  color: #000000;
  border-radius: 8px;
  padding: 10px 20px;
  line-height: 14px;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #B50604 !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/loginVerifyCode.vue